import {
    ItemResponseScheduledReportRequestObjectObject,
    ListResponseScheduledReportRequestObject,
    ScheduledReportControllerApi,
    ScheduledReportRequestObject
} from 'src/api/api';
import {BaseApi, configuration} from 'src/api/BaseApi';
import {processError} from '../../../api/customFetch';

export enum ReportType {
    PublisherRevenue = 'PublisherRevenue',
    DspSpent = 'DspSpent',
}

class ReportApi extends BaseApi {
    api: ScheduledReportControllerApi;

    constructor() {
        super();
        this.api = new ScheduledReportControllerApi(configuration, configuration.basePath, this.customFetch);
    }

    createPublisher(scheduledReportRequest: ScheduledReportRequestObject) {
        return this.api.createScheduledReport({...scheduledReportRequest})
    }

    // createDsp(params: DspReportRequestParameters) {
    //     return this.api.createDspReport({...params, type: DspReportRequestParameters.TypeEnum.ByDsp})
    // }
    //
    // get(id: string) {
    //     return this.api.getReport(id)
    // }
    //
    // createRaw(params: RawReportRequestParameters) {
    //     return this.api.createRawReport({...params, type: RawReportRequestParameters.TypeEnum.Raw})
    // }

    list(size: number = 20, page: number = 1, search?): Promise<ListResponseScheduledReportRequestObject> {
        return this.api.getScheduledReportList(search, {query: {size: size, page: page}}).then(list => {
            return Promise.resolve(list);
        }).catch(err => {
            return processError(err);
        });
    }

    all(): Promise<ListResponseScheduledReportRequestObject> {
        return this.api.getScheduledReportList().then(list => {
            return Promise.resolve(list);
        }).catch(err => {
            return processError(err);
        });
    }

    view(id: number): Promise<ItemResponseScheduledReportRequestObjectObject> {
        return this.api.getScheduledReport(id).then(dsp => {
            return Promise.resolve(dsp);
        }).catch(err => {
            return processError(err);
        });
    }

    edit(id: number, scheduledReportRequestObject: ScheduledReportRequestObject): Promise<ItemResponseScheduledReportRequestObjectObject> {
        return this.api.editScheduledReport(scheduledReportRequestObject, id).then(updated => {
            return Promise.resolve(updated);
        }).catch(err => {
            return processError(err);
        });
    }

    delete(id: number): Promise<void> {
        return this.api.deleteScheduledReport(id).then(() => {
            return Promise.resolve();
        }).catch(err => {
            return processError(err);
        });
    }
}

const reportApi = new ReportApi()

export default reportApi
